import * as React from 'react';
import { Body1, Card, Title3, makeStyles, tokens } from '@fluentui/react-components';
import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { isIOS } from '../../../../capacitor/platform';
import CorporateLogo from '../../dashboards/components/corporateLogo';
import CustomButton from '../../dashboards/components/buttons/CustomButton';
import { Stack } from '../../dashboards/components/stack/stack';

const APP_STORE_URL = 'https://apps.apple.com/app/id6823199799';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mapertech.maper';

const useStyles = makeStyles({
    card: {
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center',
    },
});

/** Replaces the whole app on a binary the backend no longer supports; the only way out is the store. */
export const NativeUpdateRequired = () => {
    const { t } = useTranslation();
    const styles = useStyles();

    // Capacitor hands top-level navigation outside the app to the OS, which opens the store app.
    const openStore = () => window.location.assign(isIOS() ? APP_STORE_URL : PLAY_STORE_URL);

    return (
        <Stack
            direction="column"
            className="app-login-bg"
            align="center"
            justify="center"
            gap={tokens.spacingVerticalL}
            padding={tokens.spacingHorizontalL}
            minHeight="100vh"
        >
            <CorporateLogo variant="static" inverse align="center" />
            <Card className={styles.card}>
                <Stack direction="column" align="center" gap={tokens.spacingVerticalM}>
                    <Title3>{t('Update required')}</Title3>
                    <Body1>{t('Update the app to keep using MAPER')}</Body1>
                    <CustomButton appearance="primary" icon={<Download size={16} />} onClick={openStore}>
                        {t('Update')}
                    </CustomButton>
                </Stack>
            </Card>
        </Stack>
    );
};
